// components/artifacts/ArtifactToolbox.js - 아티팩트 플로팅 툴박스 컴포넌트

import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faEdit,
  faSave,
  faCopy,
  faDownload,
  faTimes,
  faFileCode,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

/**
 * 아티팩트 플로팅 툴박스 컴포넌트
 * @param {object} props
 * @param {boolean} props.isEditing - 편집 모드 여부
 * @param {boolean} props.showDownloadMenu - 다운로드 메뉴 표시 여부
 * @param {string} props.artifactType - 아티팩트 타입
 * @param {function} props.onScrollToTop - 맨 위로 스크롤 핸들러
 * @param {function} props.onEdit - 수정 핸들러
 * @param {function} props.onSave - 저장 핸들러
 * @param {function} props.onCancel - 취소 핸들러
 * @param {function} props.onCopy - 복사 핸들러
 * @param {function} props.onDownloadWord - Word 다운로드 핸들러
 * @param {function} props.onDownloadPDF - PDF 다운로드 핸들러
 * @param {function} props.onGenerateGoogleFormsScript - 구글 폼 스크립트 생성 핸들러
 * @param {function} props.onDelete - 삭제 핸들러
 * @param {function} props.setShowDownloadMenu - 다운로드 메뉴 표시 상태 변경 함수
 */
const ArtifactToolbox = ({
  isEditing,
  showDownloadMenu,
  artifactType,
  onScrollToTop,
  onEdit,
  onSave,
  onCancel,
  onCopy,
  onDownloadWord,
  onDownloadPDF,
  onGenerateGoogleFormsScript,
  onDelete,
  setShowDownloadMenu,
}) => {
  return (
    <div className="floating-toolbox">
      <div className="tool-item">
        <button className="tool-btn top-btn" onClick={onScrollToTop}>
          <FontAwesomeIcon icon={faArrowUp} />
        </button>
        <span className="tool-label">Top</span>
      </div>

      <div className="toolbox-divider"></div>

      {isEditing ? (
        <>
          <div className="tool-item">
            <button className="tool-btn save-btn" onClick={onSave}>
              <FontAwesomeIcon icon={faSave} />
            </button>
            <span className="tool-label">완료</span>
          </div>
          <div className="tool-item">
            <button
              className="tool-btn cancel-btn"
              onClick={onCancel}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
            <span className="tool-label">취소</span>
          </div>
        </>
      ) : (
        <>
          {/* Survey 타입은 항상 편집 가능하므로 수정 버튼 숨김 */}
          {artifactType !== "survey" && (
            <div className="tool-item">
              <button className="tool-btn edit-btn" onClick={onEdit}>
                <FontAwesomeIcon icon={faEdit} />
              </button>
              <span className="tool-label">수정</span>
            </div>
          )}
          <div className="tool-item">
            <button className="tool-btn copy-btn" onClick={onCopy}>
              <FontAwesomeIcon icon={faCopy} />
            </button>
            <span className="tool-label">복사</span>
          </div>
          <div className="tool-item" style={{ position: "relative" }}>
            <button
              className="tool-btn download-btn"
              onClick={() => setShowDownloadMenu((v) => !v)}
            >
              <FontAwesomeIcon icon={faDownload} />
            </button>
            <span className="tool-label">저장</span>
            {showDownloadMenu && (
              <div
                style={{
                  position: "absolute",
                  top: "0",
                  right: "90px",
                  background: "white",
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                  padding: "8px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  zIndex: 200,
                }}
              >
                <button
                  onClick={() => {
                    setShowDownloadMenu(false);
                    onDownloadWord();
                  }}
                  style={{
                    border: "none",
                    background: "#f9fafb",
                    padding: "8px 12px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  }}
                >
                  Word 문서 (.docx)
                </button>
                <button
                  onClick={() => {
                    setShowDownloadMenu(false);
                    onDownloadPDF();
                  }}
                  style={{
                    border: "none",
                    background: "#f9fafb",
                    padding: "8px 12px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  }}
                >
                  PDF
                </button>
              </div>
            )}
          </div>

          {artifactType === "survey" && (
            <>
              <div className="toolbox-divider"></div>
              <div className="tool-item">
                <button
                  className="tool-btn forms-btn"
                  onClick={onGenerateGoogleFormsScript}
                  style={{
                    background: "linear-gradient(135deg, #4285f4, #34a853)",
                    color: "white",
                  }}
                >
                  <FontAwesomeIcon icon={faFileCode} />
                </button>
                <span
                  className="tool-label"
                  style={{ fontSize: "11px", lineHeight: "1.3" }}
                >
                  구글 폼<br />
                  만들기
                </span>
              </div>
            </>
          )}

          <div className="tool-item">
            <button className="tool-btn delete-btn" onClick={onDelete}>
              <FontAwesomeIcon icon={faTrash} />
            </button>
            <span className="tool-label">삭제</span>
          </div>
        </>
      )}
    </div>
  );
};

export default ArtifactToolbox;

